import { Button, Grid } from "@mui/material";
import PremiumBadgeIcon from "../../../img/icons/vip.png";
import LinkWrapper from "../../LinkWrapper/LinkWrapper";

interface JoinPremiumButtonProps {
  text?: string;
  size?: string;
}

const JoinPremiumButton = ({ text, size }: JoinPremiumButtonProps) => {
  return (
    <LinkWrapper
      visitorUrl="/sign-up"
      freeUserUrl="/upgrade-membership"
      premiumUserUrl="/upgrade-membership"
      style={{ width: size ? size : "100%" }}
      closeOnVisitor={true}
      closeOnSigned={true}
      component={
        <Button variant="premium" fullWidth>
          <Grid
            container
            direction="row"
            columnSpacing={1}
            width={"100%"}
            xs={12}
            alignItems={"center"}
            justifyContent={"center"}
          >
            <Grid item fontStyle={"italic"}>
              {text ? text : "Upgrade Membership"}
            </Grid>
            <Grid item>
              <img
                loading="lazy"
                width="20"
                src={PremiumBadgeIcon}
                alt=""
                style={{ display: "block", width: "25px" }}
              />
            </Grid>
          </Grid>
        </Button>
      }
    />
  );
};

export default JoinPremiumButton;
